// 是客户端
export const IS_CLIENT = typeof window !== 'undefined';
// 是服务端
export const IS_SERVER = typeof window === 'undefined';
// 本地开发环境
export const IS_DEV = process.env.APP_ENV === 'dev';
// 测试环境
export const IS_TEST = process.env.APP_ENV !== 'prod';
// 生产环境
export const IS_PROD = process.env.APP_ENV === 'prod';
// 打包环境
export const IS_BUILD = process.env.NODE_ENV !== 'development';
